import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Report } from '@/models/Report';
import Questionnaire from '@/components/Questionnaire/Questionnaire.vue';
import { DateFormatter } from '@/support/DateFormatter';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';

@Component<OverwriteAppointmentDialog>({
  components: {
    Questionnaire,
  },
})
export default class OverwriteAppointmentDialog extends Vue {
  @Prop()
  protected report!: Report;

  @Prop()
  protected appointmentType!: AppointmentEnum;

  protected appointment: DateFormatter = new DateFormatter();

  protected reason = '';

  protected isLoading = true;

  protected AppointmentEnum = AppointmentEnum;

  protected async mounted(): Promise<void> {
    this.isLoading = false;
  }

  protected close(): void {
    this.$emit('input', false);
  }

  protected async updateAppointment(): Promise<void> {
    if (! this.report) {
      return;
    }

    let payload: UpdateAppointmentPayload = {};

    switch (this.appointmentType) {
      case AppointmentEnum.FIRST:
        payload = {
          first_appointment: `${this.appointment.selectedDate} ${this.appointment.selectedTime}`,
          first_appointment_change_reason: this.reason,
        };
        break;
      case AppointmentEnum.DELIVERY:
        payload = {
          delivery_appointment: `${this.appointment.selectedDate} ${this.appointment.selectedTime}`,
          delivery_appointment_change_reason: this.reason,
        };
        break;
    }

    await new Report(this.report).update(payload)
      .then(() => {
        this.appointment = new DateFormatter();
        this.$emit('appointmentUpdated');
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected get isValid(): boolean {
    return !! (this.appointment && this.appointment.selectedDate && this.reason);
  }
}

interface UpdateAppointmentPayload {
  first_appointment?: string;
  first_appointment_change_reason?: string;
  delivery_appointment?: string;
  delivery_appointment_change_reason?: string;
}

export enum AppointmentEnum {
  FIRST = 'first',
  DELIVERY = 'delivery',
}
